import { useSelector } from "react-redux";
import { Modal } from "../../CommonUIComponents/Modal/Modal";
import { RepeatIcon } from "../../../icons/repeat";
import {
  fileVersionHistoryModalHeaderDate,
  fileVersionHistoryModalHeaderFileName,
  fileVersionHistoryModalHeaderUploadedBy,
  manageEmissionBodyUploadFileHistory,
  fileVersionHistoryModalLiveVersion
} from "../../../util/constants";
import { Table } from "../../CommonUIComponents/Table/Table";
import { customCellRenderer } from "./cutomCellRenderer";
import { formarDateTime } from "../../../util/dateUtil";
import { MotifChip } from '../../../assets/lib/motif';

function ModalHeader() {
  return (
    <div className="file-version-history-modal-header">
      <div className="motif-fab">
        <RepeatIcon />
      </div>
      <span>{manageEmissionBodyUploadFileHistory}</span>
    </div>
  );
}

function ModalBody() {
  const fileHistory = useSelector((state) => state.forecast.fileUploadHistory);
  const fileHistoryLoading = useSelector(
    (state) => state.forecast.fileUploadHistoryLoading
  );

  return (
    <div>
      <Table
        rowData={fileHistory}
        colDefs={[
          {
            field: "uploadDate",
            filter: true,
            headerName: fileVersionHistoryModalHeaderDate,
            headerTooltip: fileVersionHistoryModalHeaderDate,
            maxWidth: 150,
            suppressMovable: true,
            valueFormatter: (params) => {
              return formarDateTime(params.value, "dd MMMM yyyy");
            },
          },
          {
            field: 'fileName',
            filter: true,
            headerName: fileVersionHistoryModalHeaderFileName,
            headerTooltip: fileVersionHistoryModalHeaderFileName,
            flex: 1,
            minWidth:500,
            suppressMovable: true,
            cellRenderer: params => {
              return (
                <div style={{ display: 'flex' }}>
                  <p>{params.value.length > 60 ? params.value.substring(0,60) + '... ' : params.value} &nbsp;</p>
                  {params.node.data.liveVersion && (
                    <MotifChip
                      label="Live"
                      className="file-version-history-modal-live-chip"
                    >
                      {fileVersionHistoryModalLiveVersion}
                    </MotifChip>
                  )}
                </div>
              );
            },
          },      

          {
            field: "email",
            filter: true,
            headerName: fileVersionHistoryModalHeaderUploadedBy,
            headerTooltip: fileVersionHistoryModalHeaderUploadedBy,
            minWidth: 200,
            flex: 1,
            suppressMovable: true,
          },
          {
            field: "liveVersion",
            headerName: "",
            filter: true,
            cellRenderer: customCellRenderer,
            minWidth: 200,
            suppressMovable: true,
          },
        ]}
        draggable={false}
        loading={fileHistoryLoading}
      />
    </div>
  );
}

export function FileVersionHistoryModal({ isModalVisible, onClose }) {
  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={<ModalHeader />}
      body={<ModalBody />}
      size={"xl"}
      className={"file-version-history-modal"}
    />
  );
}
